// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap, no-plusplus */
import moment from "moment"
import { Record, Map } from "immutable"

import Summaries from "./Summaries"
import MonthPrices from "./MonthPrices"
import { DATE_FORMAT } from "../consts/date"

const PickPricesRecord = Record({
  months: Map(),
  unavailable: false,
  loading: false,
  loadedAny: false,
  loadedAll: false,
  summaries: new Summaries(),
})

/**
 * @param flights {Array<flight>} flights from FlightsAPI.
 * Object has to have a dTime<number> and price<number> set
 *
 * @returns {Map<date, price>} date is in YYYY-MM-DD,
 * price is the lowest for the day
 */
export function getDayPrices(flights) {
  return flights.reduce((acc, flight) => {
    const key = moment.utc(flight.dTime * 1000).format(DATE_FORMAT)

    return !acc.get(key) || acc.get(key) < flight.price ? acc.set(key, flight.price) : acc
  }, Map())
}

class PickPrices extends PickPricesRecord {
  constructor(raw = {}) {
    const input = { ...raw }
    if (input.months) {
      let loaded = 0

      input.summaries = input.months.reduce((acc, month) => {
        let next = acc

        const max = month.getIn(["summaries", "max"])
        if (next.get("max") < max) {
          next = next.set("max", max)
        }

        const min = month.getIn(["summaries", "min"])
        if (next.get("min") > min) {
          next = next.set("min", min)
        }

        next = next.set("results", next.get("results") + month.getIn(["summaries", "results"]))

        if (month.get("loading")) {
          input.loading = true
        }

        if (month.get("loaded")) {
          loaded++
        }

        return next
      }, new Summaries())

      input.loadedAny = loaded > 0
      input.loadedAll = loaded === input.months.size
    }

    super(input)
  }

  // utils
  // =====
  isMonthLoading(month) {
    return this.months.getIn([month, "loading"])
  }

  isMonthLoaded(month) {
    return this.months.getIn([month, "loaded"])
  }

  addMonthFlights(monthId, flights) {
    return this.addMonth(
      monthId,
      new MonthPrices({
        days: getDayPrices(flights),
        loading: false,
        loaded: true,
      }),
    )
  }

  addMonth(monthId, month) {
    return new PickPrices({
      months: this.months.set(monthId, month),
    })
  }

  // getters
  // =======
  getMonth(monthId) {
    return this.months.get(monthId)
  }

  getPrice(date) {
    const month = date.substring(0, 7)

    return this.months.getIn([month, "days", date])
  }

  getPercentual(price) {
    const { max } = this.summaries

    return max ? Math.round((price / max) * 100) : 0
  }

  getRelative(price) {
    const { min, max } = this.summaries

    return min && max ? Math.round(((price - min) / max) * 100) : 0
  }
}

export default PickPrices
